import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { AboutVerificationWidgetModule } from '@core/widgets';

import { IconComponent } from '@shared/icon/icon.component';
import { OnUiCoverModule } from 'onclass-ui';
import { OnboardingPersonalInfoComponent } from './onboarding-personal-info.component';

@NgModule({
  declarations: [OnboardingPersonalInfoComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,

    RouterModule,
    OnUiCoverModule,
    IconComponent,
    ModalModule,
    MobileModalModule,
    AboutVerificationWidgetModule,
  ],
  exports: [OnboardingPersonalInfoComponent],
})
export class OnboardingPersonalInfoModule {}
